import { render, staticRenderFns } from "./xuniDetail.vue?vue&type=template&id=2aa84e53&scoped=true&"
import script from "./xuniDetail.vue?vue&type=script&lang=js&"
export * from "./xuniDetail.vue?vue&type=script&lang=js&"
import style0 from "./xuniDetail.vue?vue&type=style&index=0&id=2aa84e53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa84e53",
  null
  
)

export default component.exports